import { render, staticRenderFns } from "./CheckboxSet.vue?vue&type=template&id=2016b3c0&scoped=true&"
import script from "./CheckboxSet.vue?vue&type=script&lang=js&"
export * from "./CheckboxSet.vue?vue&type=script&lang=js&"
import style0 from "./CheckboxSet.vue?vue&type=style&index=0&id=2016b3c0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2016b3c0",
  null
  
)

export default component.exports